import { Box, Grid } from "@mui/material";
import { clearAllCardSelection, setActiveActionCard, setOpenSections } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import PlanType from "components/common/PlanType";
import AddNewSection from "components/features/Sections/AddNewSection";
import { uniq } from "lodash";
import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { ABOVE_PROPERTY, accessTypes, brandDeadLine, messages } from "utils/CommonConstants";
import { responseStatusTypes } from "utils/Types";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Basictabs from "../../common/Tabs";
import ActionCardDialogsContext from "../ActionCard/Context";
import PlanDetailsContent from "../planDetails/PlanDetailsContent";
import { tabDetails } from "../planDetails/TabsConfig";
import {
  fetchAssigneeDetailsAsync,
  fetchMyPlanDetailAsync,
  setIsRedirectFromNotification
} from "./MyPlanDetails.slice";
import RecognitionsDialog from "./RecognitionsDialog";

export default function MyPlanDetails() {
  const { id: myPlanId, secId } = useParams();
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const showLoader: boolean | undefined = useAppSelector((state) => state.myPlanDetails.myPlanDetailShowLoader);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const isDeleteSuccess = useAppSelector((state) => state.formDetails.deletePlan.status);

  const { setIsOpenViewActionDialog, setIsOpenEditActionDialog } = React.useContext(ActionCardDialogsContext);

  useEffect(() => {
    if (isDeleteSuccess === responseStatusTypes.success) {
      selectedMyPlanDetail?.innCode === ABOVE_PROPERTY
        ? navigate(`/myplans?parentTab=Template+Plans`)
        : navigate(`/myplans`);
    }
  }, [isDeleteSuccess]);

  useEffect(() => {
    return () => {
      dispatch(setActiveActionCard({}));
      dispatch(setIsRedirectFromNotification(false));
      setIsOpenEditActionDialog(false);
      setIsOpenViewActionDialog(false);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchMyPlanDetailAsync({ id: myPlanId, includePropertyInfo: true }));
  }, [myPlanId]);

  const deleteCardsMessage = `Modifications can't be made. This is preconfigured to ensure a successful and on-time implementation.`;

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (myPlanId != selectedMyPlanDetail.id) return;
    const membersList = uniq([...(selectedMyPlanDetail?.owners || []), ...(selectedMyPlanDetail?.members || [])]);
    const data = {
      value: membersList,
      size: membersList?.length
    };
    dispatch(fetchAssigneeDetailsAsync(data));

    if (selectedMyPlanDetail?.sections?.length) {
      dispatch(setOpenSections({ [secId ?? selectedMyPlanDetail?.sections[0]?.id]: true }));
    }
  }, [dispatch, selectedMyPlanDetail]);

  useEffect(() => {
    dispatch(clearAllCardSelection());
  }, [selectedMyPlanDetail]);
  return (
    <>
      <Grid marginX={isMobileScreen ? "-16px" : "unset"}>
        <RecognitionsDialog />
        <Feedback form="updateMyPlanCardDetail" message={messages.editSuccess} />
        <Feedback form="createSection" message="Section Added" />
        <Feedback form="markComplete" message={useAppSelector((state) => state.formDetails["markComplete"]?.details)} />
        <Feedback form="editSection" message={messages.editSuccess} />
        <Feedback form="deleteSection" message="Section Deleted" />
        <Feedback form="deleteActionCard" message="Action Deleted" />
        <Feedback form="deleteMultipleActionCards" message={deleteCardsMessage} />
        <Feedback form="myPlanDetail" />

        {!showLoader && (
          <>
            <Grid
              sx={{
                backgroundColor: tokens.Background.General.Primary,
                padding: isMobileScreen ? "16px" : "40px 24px 40px 32px",
                borderRadius: "12px"
              }}
            >
              {selectedMyPlanDetail?.planType && (
                <Box marginBottom={"8px"}>
                  <PlanType
                    planType={selectedMyPlanDetail.planType === brandDeadLine ? 1 : 2}
                    brandDeadlineDate={selectedMyPlanDetail.brandDeadlineDate}
                    initiativeName={selectedMyPlanDetail.initiativeName}
                  />
                </Box>
              )}
              <PlanDetailsContent
                selectedPlanDetail={selectedMyPlanDetail}
                plansType="MyPlans"
                isTemplatePlan={selectedMyPlanDetail?.innCode === ABOVE_PROPERTY}
              />
            </Grid>
            <Grid marginBottom={2.5} marginTop={isMobileScreen ? "48px" : "unset"}>
              <Basictabs
                sx={{ paddingX: isMobileScreen ? "16px" : "" }}
                tabDetails={tabDetails(selectedMyPlanDetail, "MyPlans")}
                alignItems="left"
              />
            </Grid>
            <Grid>
              <AddNewSection label="Add new section" accessType={accessTypes.update} />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
